if (!customElements.get("back-to-top")) {
  customElements.define(
    "back-to-top",
    class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("click", this.scrollToTop);

        this.lastScrollTop = 0; // Stores the previous scroll position

        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener("scroll", this.onScrollHandler, false);
      }

      onScroll() {
        const currentScrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        if (currentScrollTop > this.lastScrollTop) {
          // User is scrolling down
          this.classList.remove("show");
        } else if (currentScrollTop < this.lastScrollTop) {
          // User is scrolling up
          this.classList.add("show");
        }

        this.lastScrollTop = currentScrollTop; // Update the previous scroll position

        // console.log(this.lastScrollTop);
      }

      scrollToTop(e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }
  );
}
